<div class="card">
  <div class="card-body">
    <h5>Prescriber</h5>

    <app-prescriber-incorrect-information-prompt
      [client]="task.client"
      relatedRecordType="ClientConsultNoteTask"
      [relatedRecordId]="task.id"
      [provider]="task.provider"
      [prescriberId]="task.prescriberId" />

    <div class="row mb-2 pe-2">
      <div class="col">
        <div><strong>PRESCRIBER</strong></div>
        <div><app-prescriber-name [provider]="task.provider" /></div>
        <br />
        <div><strong>SPECIALTY</strong></div>
        <div>{{ task.provider.displaySpecialty }}</div>
      </div>
      <div class="col">
        <app-prescriber-offices-scrollable [provider]="task.provider" [acceptableFaxStatusOnly]="true" />
      </div>
    </div>
  </div>
</div>
<div class="card mt-2">
  <div class="card-body">
    <app-client-consult-note-task-referrals [task]="task" />
  </div>
</div>
<app-client-task-encounters [patient]="task.patient" />
<div class="card mt-2">
    <div class="card-body">
        <app-client-consult-note-task-related-tasks [task]="task" />
    </div>
</div>
